module.exports = __webpack_public_path__ + "media/images/logo-noir-35bbb9244459d6f620996ac2f725db75.png";